import styles from '../../assets/styles/LandingPage/Header2.module.scss';
import { HashLink as Link } from 'react-router-hash-link';
import img_photo2 from '../../assets/img/img_photo2.jpg';
import { MimaButton, MimaText } from '../../components';
import { motion, AnimatePresence } from 'framer-motion';
import MimaLogo from '../../assets/img/mima-logo.png';
import { useNavigate } from 'react-router-dom';
import constant from '../../utils/constant';
import { IoMdMenu } from 'react-icons/io';
import { MdCancel } from 'react-icons/md';
import React, { useState } from 'react';

const Header = ({ scrollToSection, features, testimonial, showComingSoon }) => {
	const [menu, setMenu] = useState(false);

	const showMenu = () => {
		setMenu(!menu);
	};

	const navigate = useNavigate();
	const switchToSignup = () => {
		navigate(constant.Routes.SignUp);
	};

	const switchToLogin = () => {
		navigate(constant.Routes.Login);
	};

	return (
		<header>
			<AnimatePresence>
				{menu && (
					<motion.div
						initial={{
							opacity: 0,
							y: '-100%',
						}}
						animate={{
							opacity: 1,
							y: 0,
							transition: {
								duration: 0.5,
							},
						}}
						exit={{
							opacity: 0,

							y: '-100%',
							transition: {
								duration: 0.3,
							},
						}}
						className={styles.menu}>
						<div className={styles.menu__top}>
							<img src={MimaLogo} className={styles.menu__logo} alt="logo" />
							<div className={styles.menu__icon} onClick={showMenu}>
								<MdCancel />
							</div>
						</div>

						<nav>
							<ul className={styles.menu__nav}>
								<li className={styles.menu__nav__item}>
									<Link
										to="#features"
										className={styles.menu__nav__link}
										onClick={showMenu}>
										Products
									</Link>
								</li>
								<li className={styles.menu__nav__item}>
									<Link
										to="#testimonial"
										className={styles.menu__nav__link}
										onClick={showMenu}>
										Stories
									</Link>
								</li>
								<li className={styles.menu__nav__item}>
									<Link
										to="#subscription"
										className={styles.menu__nav__link}
										onClick={showMenu}>
										Pricing
									</Link>
								</li>
								{/* <li className={styles.menu__nav__item}>
									<Link to={constant.Routes.Article} className={styles.menu__nav__link}>
										Articles
									</Link>
								</li> */}
								<li className={styles.menu__nav__item}>
									<Link to={constant.Routes.BlogLanding} className={styles.menu__nav__link}>
										Blog
									</Link>
								</li>
								<li className={styles.menu__nav__item}>
									<Link to={constant.Routes.Contact} className={styles.menu__nav__link}>
										Contact Us
									</Link>
								</li>
								{/* <li className={styles.menu__nav__item}>
									<a href="#" className={styles.menu__nav__link}>
										Support
									</a>
								</li> */}
							</ul>
						</nav>
						<div className={styles.menu__nav__btn}>
							<MimaButton
								title="Log in"
								variant="outlined"
								onClick={switchToLogin}
								width={38}
								mb={2}
							/>
							<MimaButton
								title="Sign up and get two months free"
								onClick={switchToSignup}
							/>
						</div>
					</motion.div>
				)}
			</AnimatePresence>
			<div className={styles.header}>
				<div className={styles.header__nav}>
					<img src={MimaLogo} className={styles.logo} alt='logo' />
					<nav>
						<ul className={styles.nav__item}>
							<li className={styles.nav__item__list}>
								<Link to="#features" className={styles.menu__nav__link}>
									Products
								</Link>
							</li>
							<li className={styles.nav__item__list}>
								<Link to="#testimonial" className={styles.menu__nav__link}>
									Stories
								</Link>
							</li>
							<li className={styles.nav__item__list}>
								<Link to="#subscription" className={styles.menu__nav__link}>
									Pricing
								</Link>
							</li>
							{/* <li className={styles.nav__item__list} >
								<Link to={constant.Routes.Article} className={styles.menu__nav__link}>
									Articles
								</Link>
							</li> */}
							<li className={styles.nav__item__list} >
								<Link to={constant.Routes.BlogLanding} className={styles.menu__nav__link}>
									Blog
								</Link>
							</li>
							<li className={styles.nav__item__list} >
								<Link to={constant.Routes.Contact} className={styles.menu__nav__link}>
									Contact us
								</Link>
							</li>
						</ul>
					</nav>
					<div className={styles.header__nav__btn}>
						<MimaButton
							title="Log in"
							variant="outlined"
							onClick={switchToLogin}
						/>
						<MimaButton
							title="Sign up"
							onClick={switchToSignup}
							width={30}
						/>
					</div>
					<div className={styles.header__nav_icon} onClick={showMenu}>
						<IoMdMenu />
					</div>
				</div>
				<div className={styles.slide}>
					<div className={styles.slide__text}>
						<MimaText variant="h1" color="var(--color-primary)">
							Your Business <br /> Growth Partner

						</MimaText>
						<MimaText mb={3} mt={2}>
							As a business owner, Mima is the comprehensive tool you need. With Mima, you don’t have to worry about handling invoicing, tracking income and expenses, analyzing performance, managing taxes, and paying your team. You can do all that and more, all in one place. With Mima, running a business just got a whole lot simpler, and achieving growth just got easier.
						</MimaText>
						{/* <MimaText mb={3} mt={2}>
							We provide the tools and resources to help you expand your brand,
							reach new customers, and increase sales worldwide. Our platform
							makes it easy to showcase your products or services, connect with
							both local and international buyers. Let us
							help you take your business to the next level and tap into the
							global marketplace.
						</MimaText> */}
						<div className={styles.slide__text_btn}>
							{/* <a
								href="https://play.google.com/store/apps/details?id=com.mima.mima"
								style={{ textDecoration: 'none' }}>
								<MimaButton
									title="Get app on Android"
									variant="outlined"
									icon={playIcon}
									width={30}
								/>
							</a>

							<a
								href="https://apps.apple.com/us/app/mima-business/id6444887331"
								style={{ textDecoration: 'none' }}>
								<MimaButton
									title="Get app on iPhone"
									variant="outlined"
									icon={appleIcon}
									width={30}
								/>
							</a> */}
							<MimaButton
								title="Sign up and get 2 months free"
								onClick={switchToSignup}
								mb={2}
							/>
						</div>
					</div>
					<img src={img_photo2} className={styles.slide__img} alt='mima business' />
				</div>
			</div>
			{/* <div style={{overflow: 'hidden'}}>
				<div className={styles.businesses}>
					<MimaText className={styles.businesses__title}
						variant='subtitleBold'
						color='var(--color-primary)'
						mb={3}
					>
						1000+ Businesses Trust Mima
					</MimaText>
				</div>
				<LiveUpdate />
			</div> */}
		</header>
	);
};

export default Header;
